import { CircularProgress } from "@material-ui/core";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import useSubmitSurvey from "./hooks/useSubmitSurvey";
import useSurveyForm from "./hooks/useSurveyForm";
import useFetchSurvey from "./hooks/useFetchSurvey";
import {
  ActionsContainer,
  Container,
  ContentContainer,
  LoadingContainer,
  SubmitButton,
  SurveyContainer,
} from "./styles";
import SurveyConfig from "./SurveyConfig";
import SurveyEditor from "./SurveyEditor";

export default function EditSurvey(props) {
  const surveyID =
    props.match.params.id === "novo" ? null : props.match.params.id;

  const { data, loadingSurvey } = useFetchSurvey({ surveyID });
  const { values, onChangeValue } = useSurveyForm({ defaultValues: data });
  const { loadingSubmit, submitError, onSubmit } = useSubmitSurvey({ surveyID });

  return (
    <Container>
      <AdminMenu />
      {loadingSurvey && (
        <LoadingContainer>
          <CircularProgress size={48} style={{ color: '#393939' }} />
        </LoadingContainer>
      )}
      {!loadingSurvey && (
        <ContentContainer>
          <SurveyContainer>
            <SurveyEditor values={values} onChangeValue={onChangeValue} />
            <ActionsContainer>
              <SubmitButton
                disabled={loadingSubmit}
                onClick={() => onSubmit({ values })}
              >
                {loadingSubmit ? (
                  <>
                    Salvando
                    <CircularProgress size={16} style={{ color: "#f2f2f2" }} />
                  </>
                ) : (
                  "Salvar"
                )}
              </SubmitButton>
            </ActionsContainer>
          </SurveyContainer>
          <SurveyConfig values={values} errorMessage={submitError} onChangeValue={onChangeValue} />
        </ContentContainer>
      )}
    </Container>
  );
}